import * as i0 from '@angular/core';
import * as i1 from './global-config.module';
import * as i2 from '@delon/theme';
export const GlobalConfigModuleNgFactory:i0.NgModuleFactory<i1.GlobalConfigModule> = (null as any);
var _decl0_0:i2.DatePipe = (<any>(null as any));
var _decl0_1:i2.CNCurrencyPipe = (<any>(null as any));
var _decl0_2:i2.KeysPipe = (<any>(null as any));
var _decl0_3:i2.YNPipe = (<any>(null as any));
var _decl0_4:i2.ɵa = (<any>(null as any));
var _decl0_5:i2.HTMLPipe = (<any>(null as any));
var _decl0_6:i2.URLPipe = (<any>(null as any));
var _decl0_7:i2.AlainThemeModule = (<any>(null as any));
var _decl0_8:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_9:i0.ElementRef<any> = (<any>(null as any));
